import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Moment from "moment";
import { GetPassportRequests } from "../users/usersSlice";
import { Funnel } from "lucide-react";
import toast from "react-hot-toast";

const PassportRequest = () => {

    const [loadingData, setloadingData] = useState(true);
    const [PassportData, setPassportData] = useState([]);

    const dispatch = useDispatch();


    const fetchBooking = async () => {

        try {

            const response = await dispatch(
                GetPassportRequests()
            ).unwrap();

            if (response.status) {

                setPassportData(response.data.data);
                console.log("PassportData",response);
                
                setloadingData(false);

            } else {

                toast.error("Failed to fetch data");
                setloadingData(false);

            }

        } catch (error) {

            toast.error("Something went wrong");
            console.error(error);
            setloadingData(false);

        }

    };


    useEffect(() => {
        fetchBooking();
    }, []);   // ✅ FIXED (only once)


    return (

        <div className="bg-gray-100 text-gray-800 relative min-h-screen">

            <main className="max-w-7xl mx-auto px- sm:px-6 lg:px-8 mt-4 space-y-6">

                <div className="bg-white shadow-md rounded-lg p-4 mt-4">

                    <div className="flex items-center justify-between">
                        <h3 className="font-semibold">Passport Request</h3>

                        <button
                            className="px-5 py-2 rounded font-medium shadow flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white"
                        >
                            <Funnel size={18} />
                            Filters
                        </button>

                    </div>

                </div>


                <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">

                    <div className="text-xl font-semibold mb-3">
                        Passport Requests
                    </div>


                    <div className="overflow-x-auto">

                        <table className="min-w-full border text-sm">

                            <thead className="bg-gray-100">

                                <tr>
                                    <th className="px-3 py-2 border">No</th>
                                    <th className="px-3 py-2 border">Name</th>
                                    <th className="px-3 py-2 border">Mobile</th>
                                    <th className="px-3 py-2 border">Email</th>
                                    <th className="px-3 py-2 border">Application Type</th>
                                    <th className="px-3 py-2 border">Status</th>
                                    <th className="px-3 py-2 border">Submitted Date</th>
                                </tr>

                            </thead>


                            <tbody>

                                {loadingData ? (

                                    <tr>
                                        <td colSpan="7" className="p-3 text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                ) : PassportData?.length > 0 ? (

                                    PassportData.map((item, index) => (

                                        <tr key={index}>
                                            <td className="px-3 py-2 border">
                                                {index + 1}
                                            </td>

                                            <td className="px-3 py-2 border">
                                                {item.firstname} {item.lastname}
                                            </td>

                                            <td className="px-3 py-2 border">
                                                {item.mobile}
                                            </td>

                                            <td className="px-3 py-2 border">
                                                {item.email}
                                            </td>

                                            <td className="px-3 py-2 border">
                                                {item.application_type}
                                            </td>

                                            <td className="px-3 py-2 border">

                                                <span className={`
                                                    ${item.status === "Approved" ? "text-green-600" : ""}
                                                    ${item.status === "Rejected" ? "text-red-600" : ""}
                                                    ${item.status === "Under Review" ? "text-orange-600" : ""}
                                                `}>

                                                    {item.status}

                                                </span>

                                            </td>

                                            <td className="px-3 py-2 border">
                                                {Moment(item.submitted_at).format("DD MMM YYYY")}
                                            </td>

                                        </tr>

                                    ))

                                ) : (

                                    <tr>
                                        <td colSpan="7" className="p-3 text-center">
                                            No Record Found
                                        </td>
                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>

            </main>

        </div>

    );
};

export default PassportRequest;